import React from 'react';
import connect from "react-redux/src/components/connect";

const mapStateToProps = (state, ownProps) => {
    return {
        anonymousMode: state.user.anonymousMode
    }
}

class UrlPreview extends React.Component {
    constructor(props) {
        super(props);
        this.state = { title: '', description: '', image: '', url: '', show: false, descriptionValue: ""};
        this.onCloseClick = this.onCloseClick.bind(this);
        this.changeDescription = this.changeDescription.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (Object.keys(nextProps).length && nextProps.title !== this.props.title && nextProps.title !== this.state.title) {
            this.setState({ ...nextProps, show: true });
        }
        if (nextProps.hideUrlPreviews !== this.props.hideUrlPreviews) {
            this.setState({ ...this.state, title: '', description: '', images: '', url: '', show: false })
        }
    }

    componentDidMount() {
        if(this.props?.title){
            this.setState({
                show:true
            })
        }
    }

    changeDescription(description){
        let aa = description
        const regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;
        aa = aa.replace(regex, "<a href='$&' target='_blank'>$& </a> " + " </br> " + " </br>");
        return aa
    }

    onCloseClick() {
        this.setState({ ...this.state, title: '', description: '', images: '', url: '', show: false });
    }

    render() {
        return (
        <div className="row" hidden={!this.state.show}>
                <div className="col-md-12 card-wrapper">
                    <div className="card-outline-info card-info">
                        <button type="button" className="btn btn-sm btn-outline-warning close-button" onClick={this.onCloseClick}>
                            <i className="ion-close" />
                        </button>
                        {this.props.image && <img className="card card-img-bottom url-preview-img" src={this.props.image} alt="" />}
                        <div className="card-block">
                            <h5 className={`card-title ${this.props.anonymousMode ? "cw" : ""}`}>{this.props.title}</h5>
                            <p dangerouslySetInnerHTML={{__html: this.changeDescription(this.props.description || "") }} />
                            {/*<p>{this.state.description}</p>*/}
                            <a target="_blank" href={this.props.url} className="card-url">{this.props.url}</a>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default connect(mapStateToProps, null)(UrlPreview)
